<ion-menu side="end" type="overlay" menuId="first" contentId="content1">
  <ion-header>
    <ion-toolbar>
      <ion-buttons slot="end">
        <ion-menu-toggle auto-hide="true">
          <ion-button class="menu-close-button">
            <ion-icon
              slot="icon-only"
              name="close"
              fill="clear"
              color="light"
            ></ion-icon>
          </ion-button>
        </ion-menu-toggle>
      </ion-buttons>
    </ion-toolbar>
  </ion-header>
  <ion-content>
    <div class="menu-container">
      <div class="menu-profile">
        <app-menu-profile></app-menu-profile>
      </div>
      <div class="menu-nav">
        <ion-list>
          @for (page of navigate; track page) {
          <ion-menu-toggle auto-hide="true">
            <ion-item [routerLink]="page.url" routerDirection="forward">
              <ion-icon [name]="page.icon" slot="start"></ion-icon>
              {{ page.title }}
            </ion-item>
          </ion-menu-toggle>
          }
        </ion-list>
      </div>
      <div class="menu-footer">
        <app-menu-social></app-menu-social>
        <app-menu-copyright></app-menu-copyright>
      </div>
    </div>
  </ion-content>
</ion-menu>
